import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'retired-aud-invoice-header',
  templateUrl: './retired-aud.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./retired-aud.css']
})
export class RetiredAudInvoiceHeaderComponent {}
